export interface AppVersion {
  version: string;
  build: string;
}

export const APP_VERSION: AppVersion = {
  version: '2.0.17',
  build: '2026-10-28', 
};